import React, { Component } from 'react';

class TabletEquipment14 extends Component {
    render() {
        return (
            <div>
                <h1>사출기 14호기</h1>
            </div>
        );
    }
}

export default TabletEquipment14;